module.exports = __webpack_public_path__ + "img/vip_public_icon.15610e34.png";